{
  "unknown": "Неизвестный сбой. Повторите действие; если повторится — покажите этот экран администратору.",
  "network": {
    "unreachable": "Не удалось связаться с сервером. Проверьте связь с сетью и повторите.",
    "badResponse": "Ответ {{path}} не соответствует ожидаемому формату. Похоже, версии платформы и браузера разошлись: обновите страницу."
  },
  "validation": {
    "badRequest": "Некорректные данные запроса"
  },
  "code": {
    "byStatus": "Сервер ответил ошибкой {{status}}",
    "INTERNAL_ERROR": "Внутренняя ошибка сервера. Повторите позже.",
    "VALIDATION_FAILED": "Некорректные данные запроса",
    "NOT_FOUND": "Ресурс не найден",
    "CONFLICT": "Действие противоречит текущему состоянию",
    "RATE_LIMITED": "Слишком много запросов. Повторите позже.",
    "SERVICE_UNAVAILABLE": "Служба временно недоступна",
    "UNAUTHENTICATED": "Требуется вход в систему",
    "INVALID_CREDENTIALS": "Неверный адрес или пароль",
    "TOKEN_EXPIRED": "Срок действия сессии истёк. Войдите заново.",
    "TOKEN_INVALID": "Сессия недействительна. Войдите заново.",
    "REFRESH_TOKEN_REUSED": "Сессия завершена из соображений безопасности. Войдите заново.",
    "USER_INACTIVE": "Учётная запись отключена",
    "PERMISSION_DENIED": "Недостаточно прав для выполнения действия",
    "ORGANIZATION_NOT_FOUND": "Организация не найдена",
    "USER_NOT_FOUND": "Пользователь не найден",
    "SITE_NOT_FOUND": "Площадка не найдена",
    "NODE_NOT_FOUND": "Узел не найден",
    "MONITOR_NOT_FOUND": "Монитор не найден",
    "CREDENTIAL_NOT_FOUND": "Учётные данные не найдены",
    "CAMERA_NOT_FOUND": "Камера не найдена",
    "SESSION_NOT_FOUND": "Сессия не найдена",
    "AGENT_NOT_FOUND": "Агент не найден",
    "AGENT_OFFLINE": "Агент площадки не подключён. Проверьте, запущена ли служба netdeck-agent.",
    "ENROLLMENT_TOKEN_INVALID": "Одноразовый токен недействителен",
    "ENROLLMENT_TOKEN_USED": "Одноразовый токен уже использован",
    "TUNNEL_STREAM_FAILED": "Поток до агента площадки оборвался",
    "TUNNEL_WINDOW_EXHAUSTED": "Канал до агента переполнен: агент не успевает читать данные",
    "VNC_TICKET_INVALID": "Тикет подключения недействителен или просрочен. Подключитесь заново.",
    "VNC_PORT_CLOSED": "Порт VNC закрыт: сервер не запущен или слушает другой порт.",
    "VNC_HOST_UNREACHABLE": "Узел недоступен по сети",
    "VNC_TIMEOUT": "VNC-сервер не ответил вовремя",
    "VNC_PROTOCOL_ERROR": "VNC-сервер нарушил протокол",
    "VNC_VERSION_UNSUPPORTED": "Версия протокола RFB не поддерживается",
    "VNC_SECURITY_TYPE_UNSUPPORTED": "Способ аутентификации VNC не поддерживается",
    "VNC_AUTH_FAILED": "VNC-сервер отклонил пароль",
    "VNC_NO_CREDENTIAL": "К узлу не привязаны учётные данные VNC",
    "VNC_SERVER_CLOSED": "VNC-сервер разорвал соединение",
    "VNC_SESSION_LIMIT_REACHED": "Достигнут предел одновременных сессий",
    "SSH_TICKET_INVALID": "Тикет подключения недействителен или просрочен. Подключитесь заново.",
    "SSH_PORT_CLOSED": "Порт SSH закрыт: сервер не запущен или слушает другой порт.",
    "SSH_HOST_UNREACHABLE": "Узел недоступен по сети",
    "SSH_TIMEOUT": "SSH-сервер не ответил вовремя",
    "SSH_PROTOCOL_ERROR": "SSH-сервер нарушил протокол",
    "SSH_HOST_KEY_CHANGED": "Ключ хоста отличается от закреплённого",
    "SSH_HOST_KEY_UNTRUSTED": "Ключ хоста не закреплён",
    "SSH_AUTH_FAILED": "Сервер отклонил вход",
    "SSH_AUTH_METHOD_UNSUPPORTED": "Сервер не принимает такой способ входа",
    "SSH_NO_CREDENTIAL": "К узлу не привязаны учётные данные SSH",
    "SSH_KEY_INVALID": "Приватный ключ не разобрался",
    "SSH_NO_MATCHING_ALGORITHM": "Общего алгоритма с сервером не нашлось",
    "SSH_SERVER_CLOSED": "SSH-сервер разорвал соединение",
    "SSH_SESSION_LIMIT_REACHED": "Достигнут предел одновременных сессий",
    "SSH_SFTP_UNSUPPORTED": "Сервер не поддерживает передачу файлов по SFTP",
    "FILE_TRANSFER_UNSUPPORTED": "Сервер не поддерживает передачу файлов",
    "FILE_NOT_FOUND": "Файл не найден",
    "FILE_ACCESS_DENIED": "Нет прав на эту операцию с файлом",
    "FILE_PATH_INVALID": "Недопустимый путь",
    "FILE_TOO_LARGE": "Файл больше допустимого предела",
    "FILE_TRANSFER_FAILED": "Передача файла не удалась",
    "CAMERA_PROBE_FAILED": "Не удалось опросить камеру",
    "CAMERA_STREAM_FAILED": "Поток с камеры не открылся",
    "STREAM_TICKET_INVALID": "Тикет на просмотр недействителен или просрочен",
    "MEDIA_SERVER_UNAVAILABLE": "Медиасервер go2rtc недоступен",
    "CODEC_UNSUPPORTED": "Кодек потока браузер не понимает",
    "ARCHIVE_UNSUPPORTED": "Камера не умеет отдавать архив выбранным способом",
    "ARCHIVE_UNAVAILABLE": "Архив камеры сейчас недоступен",
    "STREAM_LIMIT_REACHED": "Достигнут предел одновременных потоков",
    "MASTER_KEY_MISSING": "Шифрование учётных данных не настроено",
    "DECRYPTION_FAILED": "Не удалось расшифровать учётные данные"
  },
  "auth": {
    "required": "Требуется вход в систему",
    "sessionInvalid": "Сессия истекла или токен недействителен",
    "sessionMissing": "Сессия не найдена. Войдите заново.",
    "sessionRevoked": "Сессия завершена из соображений безопасности. Войдите заново.",
    "sessionExpired": "Сессия истекла. Войдите заново.",
    "badCredentials": "Неверный адрес или пароль",
    "userInactive": "Учётная запись отключена",
    "wrongCurrentPassword": "Текущий пароль указан неверно",
    "permissionsNotDeclared": "Для этого действия не объявлены необходимые права",
    "needPermissions": "Недостаточно прав. Требуется: {{list}}",
    "needAnyPermission": "Недостаточно прав. Требуется одно из: {{list}}",
    "tooManyAttempts": "Слишком много попыток входа. Повторите через {{seconds}} с."
  },
  "route": {
    "noAddress": "У узла не указан адрес, подключаться не к чему."
  },
  "agents": {
    "notFound": "Агент не найден",
    "updateOffline": "Агент «{{name}}» не подключён: обновлять нечего. Проверьте, запущена ли служба netdeck-agent на площадке.",
    "updateNotNeeded": "Агент «{{name}}» уже нужной версии либо для его платформы ({{platform}}) нет сборки.",
    "buildLinkInvalid": "Ссылка на сборку недействительна или уже использована",
    "buildSizeMismatch": "Сборка {{file}} в каталоге не совпадает с манифестом по размеру. Пересоберите releases.json.",
    "buildUnknown": "В каталоге сборок нет «{{id}}»",
    "buildFileMissing": "Файл {{file}} значится в манифесте, но в каталоге сборок его нет",
    "enrollTokenUsed": "Одноразовый токен недействителен или уже использован. Выпустите новый в разделе «Площадки и агенты».",
    "siteTaken": "Площадку «{{site}}» уже обслуживает агент «{{name}}». Снимите её с него или выберите другую: два агента на площадке выполняли бы одни и те же проверки дважды.",
    "probeOffline": "Агент «{{name}}» не подключён к платформе. Проверьте, запущена ли служба netdeck-agent на площадке.",
    "probeTimeout": "Агент «{{name}}» не ответил на запрос соединения за {{ms}} мс. Возможно, площадка перегружена или связь нестабильна.",
    "probeFailed": "Агент не смог подключиться к {{host}}:{{port}}: {{detail}}"
  },
  "sites": {
    "notFound": "Площадка не найдена"
  },
  "users": {
    "notFound": "Пользователь не найден",
    "emailExists": "Пользователь с таким адресом уже есть в организации",
    "cannotDisableSelf": "Нельзя отключить собственную учётную запись",
    "cannotResetOwnPassword": "Собственный пароль меняется через смену пароля, а не сбросом: сброс обрывает текущую сессию.",
    "roleNotFound": "Роль не найдена"
  },
  "organizations": {
    "notFound": "Организация не найдена",
    "slugExists": "Организация со слагом «{{slug}}» уже существует"
  },
  "nodes": {
    "notFound": "Узел не найден",
    "notFoundAtSite": "Узел не найден на этой площадке",
    "duplicateInBatch": "Один и тот же узел указан в пакете дважды",
    "groupNotFound": "Группа не найдена",
    "groupSelfNesting": "Группа не может быть вложена сама в себя",
    "groupIntoOwnChild": "Группу нельзя вложить в её собственную подгруппу",
    "linkNotFound": "Связь не найдена",
    "layerNotFound": "Слой не найден",
    "layerNotAtSite": "Слой не найден на этой площадке",
    "layerExists": "Слой «{{name}}» на этой площадке уже есть",
    "layerNotEmpty": "На слое «{{name}}» ещё {{nodes}} узлов и {{groups}} рамок. Перенесите их на другой слой или удалите.",
    "lastLayer": "Это единственный слой площадки: без слоя карте некуда класть узлы.",
    "noLayers": "У площадки нет ни одного слоя карты",
    "frameOnOtherLayer": "Рамка «{{name}}» лежит на другом слое. Узел и его рамка должны быть на одном."
  },
  "monitors": {
    "notFound": "Монитор не найден",
    "targetRequired": "У узла не задан адрес, поэтому цель проверки нужно указать явно",
    "portRequired": "Для проверки типа {{kind}} нужно указать порт",
    "timeoutOverInterval": "Предел ожидания не должен превышать интервал проверки",
    "badConfig": "Некорректные параметры проверки типа {{kind}}",
    "agentOffline": "Агент площадки не подключён, выполнять проверку некому. Проверьте службу netdeck-agent в разделе «Агенты».",
    "addressManaged": "Параметры проверки дополнительного адреса наследуются от основного монитора узла"
  },
  "credentials": {
    "notFound": "Учётные данные не найдены",
    "secretTooLong": "Секрет длиннее {{max}} символов",
    "passphraseOnlyForKey": "Парольная фраза бывает только у приватного ключа",
    "attachedToNodes": "Учётные данные привязаны к узлам ({{count}}). Сначала отвяжите их.",
    "kindNotForService": "Учётные данные вида «{{kind}}» нельзя привязать к службе «{{service}}»",
    "notPrivateKey": "Это не приватный ключ: ожидается PEM, начинающийся с «-----BEGIN … PRIVATE KEY-----». Открытый ключ (id_rsa.pub) здесь не подойдёт.",
    "keyTruncated": "Ключ выглядит обрезанным: не хватает завершающей строки «-----END … PRIVATE KEY-----».",
    "keyEncryptedNoPassphrase": "Ключ зашифрован, а парольная фраза не задана: подключиться с ним не выйдет."
  },
  "cameras": {
    "notFound": "Камера не найдена",
    "nodeNotFound": "Узел камеры не найден",
    "nodeNotCamera": "Узел «{{name}}» не камера, а «{{kind}}». Смените тип узла или выберите другой.",
    "alreadyExists": "У узла «{{name}}» камера уже заведена.",
    "disabled": "Камера «{{name}}» отключена. Включите её в настройках камеры.",
    "agentOffline": "Агент площадки не подключён, до камеры не дотянуться. Проверьте, запущена ли служба netdeck-agent.",
    "localPortFailed": "Не удалось открыть локальный порт для потока камеры.",
    "emptySdp": "Пустое предложение SDP: браузер не прислал описание сессии.",
    "ticketMismatch": "Тикет выдан на другую камеру или другому пользователю.",
    "viewTicketInvalid": "Тикет на просмотр недействителен или просрочен. Откройте камеру заново.",
    "viewFinished": "Просмотр уже завершён. Откройте камеру заново.",
    "ticketIssueFailed": "Не удалось выдать тикет на просмотр. Повторите попытку.",
    "streamLimit": "Открыто {{active}} потоков из {{limit}}. Закройте лишние ячейки или выберите раскладку поменьше.",
    "managedByRecorder": "Камера — канал {{channel}} регистратора «{{name}}». Её пути и настройки задаёт регистратор: поменяйте их в свойствах регистратора или определите каналы заново."
  },
  "recorders": {
    "notFound": "Регистратор не найден",
    "nodeNotRecorder": "Узел «{{name}}» не видеорегистратор, а «{{kind}}». Смените тип узла или выберите другой.",
    "alreadyExists": "У узла «{{name}}» регистратор уже заведён.",
    "templateRequired": "Регистратору без API нужен шаблон пути RTSP с {channel} — иначе каналы не из чего собрать.",
    "noChannels": "Регистратор не отдал ни одного канала (проверялось до {{max}}). Проверьте протокол, порт и учётные данные, а у RTSP — шаблон пути.",
    "channelSilent": "Канал {{channel}} не отдал видео при определении каналов: вход пуст или камера за ним не на связи.",
    "authFailed": "Регистратор отклонил запрос: неверный логин или пароль. Проверьте учётные данные RTSP, привязанные к узлу, — API регистратора использует их же.",
    "httpStatus": "Регистратор ответил {{status}} на запрос {{path}}. Проверьте, тот ли выбран протокол и верен ли порт веб-интерфейса.",
    "dahuaUnexpected": "Регистратор ответил на запрос каналов Dahua не тем, чего ждали. Похоже, выбран не тот протокол.",
    "hikvisionUnexpected": "Регистратор ответил на запрос каналов ISAPI не тем, чего ждали. Похоже, выбран не тот протокол."
  },
  "media": {
    "go2rtcDown": "Медиасервер go2rtc не отвечает. Проверьте, запущена ли служба go2rtc.",
    "go2rtcRejected": "Медиасервер go2rtc отклонил запрос: {{detail}}",
    "proxyHostUnknown": "Медиасервер go2rtc не знает имени «{{host}}» и не может дотянуться до RTSP-прокси платформы. Камера тут ни при чём: через прокси идут камеры закрытых сегментов, и он живёт внутри api. Задайте CAMERA_PROXY_ADVERTISE_HOST — имя, по которому go2rtc видит api: в Compose это «api», а когда api запущен процессом на хосте, а go2rtc в контейнере — «host.docker.internal». Исходный ответ медиасервера: {{detail}}"
  },
  "layouts": {
    "notFound": "Раскладка не найдена",
    "sharedRequiresAdmin": "Общие раскладки заводит администратор организации. Сохраните раскладку как свою.",
    "sharedDeleteRequiresAdmin": "Общую раскладку удаляет администратор организации.",
    "foreignCameras": "В раскладке есть камеры из другой организации."
  },
  "archive": {
    "cameraAuthFailed": "Камера отклонила запрос {{what}}: неверный логин или пароль. Проверьте учётные данные RTSP, привязанные к узлу, — веб-интерфейс камеры использует их же.",
    "cameraUnknownRequest": "Камера не знает запроса {{what}} (404). Скорее всего выбран не тот провайдер архива.",
    "cameraStatus": "Камера ответила {{status}} на запрос {{what}}.",
    "cameraStatusDetail": "Камера ответила {{status}} на запрос {{what}}: {{detail}}.",
    "cameraStatusAsked": "Камера ответила {{status}} на запрос {{what}}. Запрошено: {{path}}",
    "cameraStatusDetailAsked": "Камера ответила {{status}} на запрос {{what}}: {{detail}}. Запрошено: {{path}}",
    "cameraHttpDown": "Камера не отвечает по HTTP: {{detail}}. Проверьте, включён ли её веб-интерфейс и верен ли порт в настройках архива.",
    "responseTooLong": "Камера прислала неправдоподобно длинный ответ на запрос списка записей.",
    "exportTooLong": "За один раз выгружается не больше {{max}} минут записи. Более длинные фрагменты забирают у площадки канал, по которому идёт живое видео.",
    "exportUnsupported": "Выбранный способ доступа к архиву не умеет отдавать фрагмент файлом. Запись можно посмотреть, но не выгрузить.",
    "exportRefused": "Камера отказалась отдавать фрагмент ({{status}}). Проверьте, что запись за этот интервал ещё не перезаписана.",
    "providerUnknown": "Способ доступа к архиву «{{provider}}» платформе неизвестен.",
    "dahuaNoFiles": "В выделенном интервале камера не нашла ни одного файла записи.",
    "dahuaUnexpected": "Камера ответила на запрос поиска не тем, чего ждали. Похоже, выбран не тот провайдер архива.",
    "dahuaAllFormsRejected": "Камера отвергла все известные формы запроса списка записей (400 Error). Похоже, её CGI отличается от Dahua сильнее, чем предполагалось: проверьте, тот ли выбран способ доступа к архиву и верен ли номер канала. Пробовали: {{tried}}",
    "hikvisionUnexpected": "Камера ответила на запрос ISAPI не тем, чего ждали. Похоже, выбран не тот провайдер архива.",
    "rtspTemplateSlash": "Шаблон архивного адреса должен начинаться со слэша, а получилось «{{path}}». Поправьте его в настройках архива камеры.",
    "cameraSilent": "Камера «{{name}}» не ответила на запрос архива. Проверьте, отвечает ли её веб-интерфейс."
  },
  "discovery": {
    "alreadyRunning": "Сканирование площадки «{{name}}» уже идёт. Дождитесь окончания или откройте его результат.",
    "agentOffline": "Агент «{{name}}» не подключён: сканировать подсеть некому. Проверьте, запущена ли служба netdeck-agent на площадке.",
    "agentNotAtSite": "Площадку обслуживает уже другой агент. Обновите страницу и повторите: сканировать нужно из того сегмента, где площадка на самом деле.",
    "noAgents": "У площадки нет агента. Заведите его в разделе «Агенты» и запустите на сервере площадки — сканировать подсеть больше некому.",
    "agentSilent": "Агент не прислал результат за пять минут. Проверьте связь с площадкой и её журнал, затем повторите сканирование."
  },
  "files": {
    "gatewayNoContent": "Шлюз доступа не прислал содержимое файла.",
    "gatewayDown": "Шлюз доступа не отвечает. Проверьте, запущена ли служба netdeck-access-gateway.",
    "gatewayRejected": "Шлюз доступа отклонил файловую операцию (HTTP {{status}}).",
    "internalChannelMissing": "Служебный канал до шлюза доступа не настроен: не задан NETDECK_INTERNAL_TOKEN.",
    "noFileInRequest": "В запросе нет файла: ожидается multipart с полем path и файлом.",
    "noPathField": "В multipart нет поля path. Оно должно идти перед файлом.",
    "foreignSession": "Файлы доступны только через собственную сессию: чужая сессия — это чужое подключение к машине.",
    "sessionClosed": "Сессия закрыта: файловый доступ к машине завершён вместе с ней.",
    "pathTraversal": "Недопустимый путь: переходы «..» запрещены.",
    "pathInvalid": "Недопустимый путь: {{path}}",
    "postExpected": "Ожидается POST",
    "notFoundAt": "На машине нет {{path}}.",
    "fileNotFoundAt": "На машине нет файла {{path}}.",
    "isDirectory": "{{path}} — каталог, а не файл.",
    "noSuchPath": "На машине нет такого пути: {{detail}}.",
    "accessDenied": "Прав на эту операцию у пользователя нет: {{detail}}.",
    "serverRejected": "Сервер отклонил операцию: {{detail}}",
    "sftpOperationUnsupported": "Сервер не поддерживает эту операцию SFTP: {{detail}}.",
    "sftpNoConnectionParams": "Запрос к файлам по SFTP пришёл без параметров подключения.",
    "operationFailed": "Операция не выполнена: {{detail}}.",
    "protocolViolation": "Сервер ответил не по протоколу: {{detail}}",
    "uploadHeaderMissing": "Не задан заголовок {{header}} с параметрами выгрузки.",
    "transferUnsupported": "Сервер ({{kind}}) не объявил передачу файлов. Расширение есть только у TightVNC и только когда оно включено в его настройках.",
    "channelClosed": "Файловый канал закрыт. Откройте файлы заново.",
    "handshakeTimeout": "Сервер {{host}}:{{port}} не завершил рукопожатие файлового канала за {{seconds}} с.",
    "streamCutShort": "Поток оборвался, не дойдя до конца файла.",
    "tooLarge": "Файл {{name}} размером {{size, bytes}} превышает предел {{limit, bytes}} на одну передачу.",
    "tooManyTransfers": "В этой сессии уже идёт передач: {{active}} из {{limit}}. Дождитесь окончания или отмените одну."
  },
  "sessions": {
    "notFound": "Сессия не найдена",
    "closeForeignForbidden": "Завершать чужие сессии вправе администратор организации",
    "perUserLimit": "Уже открыто {{open}} сессий из {{limit}}. Закройте одну из них.",
    "perOrgLimit": "В организации уже открыто {{open}} сессий из {{limit}}."
  },
  "notifications": {
    "channelNotFound": "Канал уведомлений не найден",
    "ruleNotFound": "Правило уведомлений не найдено",
    "telegramTokenRequired": "Каналу Telegram нужен токен бота: получите его у @BotFather и вставьте в поле «Токен».",
    "badChannelConfig": "Некорректные настройки канала «{{kind}}»",
    "smtpNotConfigured": "Почтовый сервер платформы не настроен: задайте SMTP_URL и SMTP_FROM в её окружении. Канал e-mail без них не работает; Telegram и webhook работают.",
    "telegramTokenMissing": "У канала Telegram не задан токен бота: получите его у @BotFather и впишите в настройках канала.",
    "telegramRejected": "Telegram отклонил сообщение ({{status}}). Проверьте токен бота и то, что бот добавлен в чат. Ответ Telegram: {{detail}}",
    "signingKeyMissing": "У канала включена подпись, но ключ подписи не задан: впишите его в настройках канала или выключите подпись.",
    "webhookRejected": "Приёмник webhook ответил {{status}}. Проверьте адрес и то, что приёмник принимает POST с телом JSON. Его ответ: {{detail}}",
    "unknownSendFailure": "Отправка не удалась, причина неизвестна. Подробности — в журнале api за это время."
  },
  "ssh": {
    "hostKeyConfirmForbidden": "Подтверждать смену ключа хоста вправе тот, кому доверены учётные данные.",
    "hostKeyServerSilent": "Сервер не отвечает: подтверждать нечего, ключ прочитать не удалось.",
    "hostKeyChangedAgain": "Сервер предъявляет уже другой ключ, чем тот, который вам показали. Откройте сведения о сервере заново и сверьте отпечаток.",
    "hostKeyChanged": "Ключ хоста {{host}} отличается от запомненного платформой. Так выглядит и переустановка сервера, и подмена машины в сети: пока причина не выяснена, подключение не состоится и пароль на этот сервер не уйдёт.",
    "hostKeyUntrusted": "Ключ хоста {{host}} не закреплён, а закреплять его в этом месте нельзя.",
    "credentialMissing": "Для подключения к {{host}} нужны учётные данные SSH, а к узлу они не привязаны.",
    "usernameMissing": "В учётных данных, привязанных к узлу, не задано имя пользователя.",
    "internalChannelMissing": "Служебный канал до шлюза доступа не настроен: не задан NETDECK_INTERNAL_TOKEN.",
    "gatewayDown": "Шлюз доступа не отвечает. Проверьте, запущена ли служба netdeck-access-gateway.",
    "gatewayTimeout": "Шлюз доступа не ответил за {{seconds}} с. Служба запущена, но зондирование не завершилось — причина в журнале netdeck-access-gateway.",
    "gatewayProbeRejected": "Шлюз доступа отклонил запрос зондирования (HTTP {{status}}).",
    "ticketIssueFailed": "Не удалось выдать тикет на сессию. Повторите попытку.",
    "protocolViolation": "Сервер нарушил протокол SSH: {{detail}}.",
    "noAlgorithmAtAll": "Сервер не поддерживает ни одного известного платформе алгоритма {{kind}}, даже из устаревших. Такое оборудование платформа обслуживать не умеет.",
    "noModernAlgorithm": "Сервер не поддерживает ни одного алгоритма {{kind}} из современного набора. Если это старое сетевое оборудование, включите на узле «устаревшие алгоритмы».",
    "authRejected": "Сервер отклонил вход пользователя {{username}} ({{method}}).",
    "methodUnsupported": "Сервер не принимает вход способом «{{method}}». Он предлагает: {{offered}}.",
    "methodUnsupportedSilent": "Сервер не принимает вход способом «{{method}}» и не назвал, какие способы принимает.",
    "interactivePrompt": "Сервер спрашивает то, чего платформа за пользователя не знает: «{{prompt}}». Такой вход (например, с одноразовым кодом) через платформу невозможен.",
    "noCredential": "Для подключения к {{host}}:{{port}} нужны учётные данные, а к узлу они не привязаны.",
    "keyNeedsPassphrase": "Приватный ключ зашифрован, а парольная фраза не задана или не подходит.",
    "keyUnreadable": "Приватный ключ не разобрался: {{detail}}.",
    "sftpUnsupported": "Сервер не поддерживает передачу файлов по SFTP. Терминал при этом работает.",
    "connectFailed": "Не удалось подключиться к {{host}}:{{port}} по SSH: {{detail}}."
  },
  "vnc": {
    "internalChannelMissing": "Служебный канал до шлюза доступа не настроен: не задан NETDECK_INTERNAL_TOKEN.",
    "gatewayDown": "Шлюз доступа не отвечает. Проверьте, запущена ли служба netdeck-access-gateway.",
    "gatewayProbeRejected": "Шлюз доступа отклонил запрос зондирования (HTTP {{status}}).",
    "ticketIssueFailed": "Не удалось выдать тикет на сессию. Повторите попытку.",
    "versionUnsupported": "Сервер говорит на версии RFB «{{banner}}», а платформа поддерживает 3.3, 3.7 и 3.8.",
    "noSecurityTypes": "Сервер не предложил ни одного типа безопасности.",
    "securityTypeUnsupported": "Сервер требует аутентификацию, которую платформа не поддерживает: {{types}}. Поддерживаются 1 (без пароля), 2 (VNC Authentication) и 16 (Tight).",
    "authFailed": "Сервер отклонил пароль VNC.",
    "authFailedWithReason": "Сервер отклонил пароль VNC: {{reason}}.",
    "noCredential": "Сервер {{host}}:{{port}} требует пароль, а к узлу не привязаны учётные данные VNC.",
    "noCredentialHere": "Сервер требует пароль, а к узлу не привязаны учётные данные VNC.",
    "protocolViolation": "Сервер нарушил протокол RFB: {{detail}}."
  },
  "gateway": {
    "service": {
      "vnc": "VNC-сервер",
      "ssh": "SSH-сервер"
    },
    "reason": {
      "noRoute": "маршрута до него нет",
      "netUnreachable": "сеть недоступна",
      "nameNotResolved": "имя не разрешается в адрес",
      "connectionReset": "соединение сброшено"
    },
    "portClosed": "Порт {{port}} на {{host}} закрыт: {{service}} не запущен или слушает другой порт.",
    "hostUnreachable": "Узел {{host}} недоступен: {{detail}}.",
    "timedOut": "Сервер {{host}}:{{port}} не ответил за {{seconds}} с.",
    "serverClosed": "Сервер разорвал соединение без объяснения причины.",
    "serverClosedWithReason": "Сервер разорвал соединение: {{reason}}.",
    "connectFailed": "Не удалось подключиться к {{host}}:{{port}}: {{detail}}.",
    "handshakeTimeout": "Сервер {{host}}:{{port}} не завершил рукопожатие за {{seconds}} с.",
    "routeAgentMissing": "Маршрут через агента выбран, но агент не указан.",
    "internalChannelMissing": "Служебный канал до api не настроен: не задан NETDECK_INTERNAL_TOKEN. Подключение через агента площадки невозможно.",
    "internalChannelRejected": "Служебный канал до api отклонил шлюз: секреты NETDECK_INTERNAL_TOKEN не совпадают.",
    "internalChannelClosed": "Служебный канал закрыт с кодом {{code}}.",
    "internalChannelClosedWithReason": "Служебный канал закрыт с кодом {{code}}: {{reason}}.",
    "agentOffline": "Агент площадки не подключён. Проверьте, запущена ли служба netdeck-agent.",
    "agentLost": "Связь с агентом площадки прервалась во время работы.",
    "agentConnectFailed": "Агент площадки не смог соединиться с {{host}}:{{port}}: {{reason}}.",
    "agentConnectFailedSilent": "Агент площадки не смог соединиться с {{host}}:{{port}}: причина не сообщена.",
    "badProbeRequest": "Некорректный запрос зондирования"
  },
  "tunnel": {
    "agentOffline": "Агент площадки не подключён. Проверьте, запущена ли служба netdeck-agent.",
    "closed": "Туннель до агента площадки закрыт. Дождитесь, пока агент подключится заново, или проверьте службу netdeck-agent на площадке.",
    "agentNoAnswer": "Агент площадки не ответил на запрос соединения с {{host}}:{{port}} за {{ms}} мс. Проверьте, что устройство включено и что агент его видит."
  },
  "secrets": {
    "masterKeyNotSet": "Шифрование учётных данных недоступно: переменная {{env}} не задана. Задайте её (base64 от 32 байт) и перезапустите службу.",
    "masterKeyEmpty": "Шифрование учётных данных недоступно: переменная {{env}} пуста. Задайте её (base64 от 32 байт) и перезапустите службу.",
    "masterKeyNotBase64": "Шифрование учётных данных недоступно: переменная {{env}} не является корректным base64. Задайте её заново и перезапустите службу.",
    "masterKeyWrongSize": "Шифрование учётных данных недоступно: мастер-ключ должен быть {{expected}} байт, получено {{actual}}. Сгенерируйте новый ключ и перезапустите службу.",
    "keyVersionMismatch": "Не удалось расшифровать учётные данные: запись зашифрована ключом версии {{sealed}}, а в окружении версия {{current}}.",
    "corruptedEnvelope": "Не удалось расшифровать учётные данные: повреждены вектор инициализации или тег аутентичности.",
    "wrongKeyOrCorrupted": "Не удалось расшифровать учётные данные: не тот ключ либо запись повреждена."
  },
  "internal": "Внутренняя ошибка платформы. Повторите действие; если оно не проходит и дальше, покажите администратору журнал api за это время — в нём есть запись с подробностями.",
  "telemetry": {
    "jsonExpected": "Ожидается сообщение в формате JSON.",
    "unknownMessage": "Неизвестное сообщение.",
    "noMonitorRead": "Нет права на чтение мониторов."
  },
  "health": {
    "probeTimeout": "Зависимость не ответила за {{ms}} мс.",
    "unknown": "Неизвестный сбой зависимости."
  }
}
